module.exports = __webpack_public_path__ + "static/img/22430605.253b728.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/22430605.jpg
// module id = HBSt
// module chunks = 0